export default __webpack_public_path__ + "static/media/Devangi Bedi.9b4ad496.jpg";